export default __webpack_public_path__ + "static/media/jeep.2002b4f0.png";